import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios';
import SecureLS from 'secure-ls';
import MessageInfoBox from '../../components/other/MessageInfoBox';
import styles from '../../css/HuaweiEventLogin.module.css';
import { axiosinstance } from '../../configAxios';
import { happeningHuaweiEvent } from '../../redux/actions/userActions';

const HAPPENING_NAME = 'HuaweiEvent2026';

const HuaweiEventLogin = () => {
    const dispatch = useDispatch();
    const [isRegistrationOpen, setIsRegistrationOpen] = useState(true);

    const [isValidName, setIsValidName] = useState(0);
    const [isValidCompany, setIsValidCompany] = useState(0);
    const [isValidEmail, setIsValidEmail] = useState(0);
    const [isValidPosition, setIsValidPosition] = useState(0);

    const [name, setName] = useState('');
    const [company, setCompany] = useState('');
    const [email, setEmail] = useState('');
    const [position, setPosition] = useState('');
    const [isRegistered, setIsRegistered] = useState(0);
    const [alreadyRegistered, setAlreadyRegistered] = useState(false);

    useEffect(() => {
        const ls = new SecureLS({ encodingType: 'aes' });
        const userInfoData = ls.get('userInfo');

        const attributes = {};
        attributes['anUserKey'] = userInfoData ? userInfoData.company.department[0].user[0].anUserKey : 0;
        attributes['acHappeningName'] = HAPPENING_NAME;

        const configRes = axiosinstance(attributes, '8224', 'happeningCheck');

        axios(configRes)
            .then((response) => {
                const { isOk, acMsg } = response.data.response;
                if (isOk === 1) return;
                // Rok za prijavu je na backendu, happeningCheck javlja kada je istekao
                if (acMsg === 'happeningDateExpirePareseError') {
                    setIsRegistrationOpen(false);
                } else {
                    setAlreadyRegistered(true);
                }
            })
            .catch((error) => {
                console.error('happeningCheck error:', error);
            });
    }, []);

    const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

    const onChangeInput = (e) => {
        const { name: fieldName, value } = e.target;
        if (fieldName === 'inputName') setName(value);
        if (fieldName === 'inputCompany') setCompany(value);
        if (fieldName === 'inputEmail') setEmail(value);
        if (fieldName === 'inputPosition') setPosition(value);
    };

    const handleSubmit = () => {
        const validName = name.trim() !== '' ? 2 : 1;
        const validCompany = company.trim() !== '' ? 2 : 1;
        const validEmail = email.trim() === '' ? 1 : (validateEmail(email) ? 2 : 1);
        const validPosition = position.trim() !== '' ? 2 : 1;

        setIsValidName(validName);
        setIsValidCompany(validCompany);
        setIsValidEmail(validEmail);
        setIsValidPosition(validPosition);

        if (validName !== 2 || validCompany !== 2 || validPosition !== 2) {
            toast(<MessageInfoBox message="errorMissingOneOrMoreFields" type="0" />, { className: 'red-background' });
            return;
        }
        if (validEmail !== 2) {
            toast(<MessageInfoBox message="emailNotFoundError" type="0" />, { className: 'red-background' });
            return;
        }

        const payload = {
            acName: name,
            acCompany: company,
            acEmail: email,
            acOption1: position,
            acType: HAPPENING_NAME,
        };
        dispatch(happeningHuaweiEvent(payload)).then(res => {
            if (!res) {
                setIsRegistered(2);
                return;
            }
            if (res.isOk === 1) {
                setIsRegistered(1);
            } else {
                setIsRegistered(2);
            }
        }).catch((err) => {
            console.error('happeningHuaweiEvent error:', err);
        });
    };

    if (isRegistered === 1) {
        return (
            <div className={styles['page-wrapper']}>
                <div className={styles['form-card']}>
                    <div className={styles['logo-wrapper']}>
                        <img src="https://resource.ewe.rs/media/HuaweiEvent2026/white-ewe_logo.png" alt="EWE logo" className={styles['logo-img']} />
                        <img src="https://resource.ewe.rs/media/HuaweiEvent2026/white-huawei_ekit_logo.png" alt="Huawei eKit logo" className={styles['logo-img']} />
                    </div>
                    <h1 className={styles['title']}>Hvala!</h1>
                    <p className={styles['subtitle']}>Vaša prijava je uspešno primljena.</p>
                </div>
            </div>
        );
    }

    if (alreadyRegistered) {
        return (
            <div className={styles['page-wrapper']}>
                <div className={styles['form-card']}>
                    <div className={styles['logo-wrapper']}>
                        <img src="https://resource.ewe.rs/media/HuaweiEvent2026/white-ewe_logo.png" alt="EWE logo" className={styles['logo-img']} />
                        <img src="https://resource.ewe.rs/media/HuaweiEvent2026/white-huawei_ekit_logo.png" alt="Huawei eKit logo" className={styles['logo-img']} />
                    </div>
                    <h1 className={styles['title']}>Već ste prijavljeni</h1>
                    <p className={styles['subtitle']}>Vaša prijava za ovaj event je već zabeležena.</p>
                </div>
            </div>
        );
    }

    if (!isRegistrationOpen) {
        return (
            <div className={styles['page-wrapper']}>
                <div className={styles['form-card']}>
                    <div className={styles['logo-wrapper']}>
                        <img src="https://resource.ewe.rs/media/HuaweiEvent2026/white-ewe_logo.png" alt="EWE logo" className={styles['logo-img']} />
                        <img src="https://resource.ewe.rs/media/HuaweiEvent2026/white-huawei_ekit_logo.png" alt="Huawei eKit logo" className={styles['logo-img']} />
                    </div>
                    <h1 className={styles['title']}>Registracija je istekla</h1>
                    <p className={styles['subtitle']}>Nažalost, rok za prijavu je prošao.</p>
                    <p className={styles['subtitle']}>Hvala na interesovanju.</p>
                </div>
            </div>
        );
    }

    return (
        <div className={styles['page-wrapper']}>
            <div className={styles['form-card']}>
                <div className={styles['logo-wrapper']}>
                    <img src="https://resource.ewe.rs/media/HuaweiEvent2026/white-ewe_logo.png" alt="EWE logo" className={styles['logo-img']} />
                    <img src="https://resource.ewe.rs/media/HuaweiEvent2026/white-huawei_ekit_logo.png" alt="Huawei eKit logo" className={styles['logo-img']} />
                </div>

                <h1 className={styles['title']}>Prijava</h1>

                <div className={styles['field-group']}>
                    <label className={styles['field-label']} htmlFor="inputName">IME I PREZIME</label>
                    <input
                        id="inputName"
                        name="inputName"
                        type="text"
                        value={name}
                        onChange={onChangeInput}
                        className={`${styles['field-input']} ${isValidName === 1 ? styles['field-input--error'] : ''}`}
                    />
                </div>

                <div className={styles['field-group']}>
                    <label className={styles['field-label']} htmlFor="inputCompany">KOMPANIJA</label>
                    <input
                        id="inputCompany"
                        name="inputCompany"
                        type="text"
                        value={company}
                        onChange={onChangeInput}
                        className={`${styles['field-input']} ${isValidCompany === 1 ? styles['field-input--error'] : ''}`}
                    />
                </div>

                <div className={styles['field-group']}>
                    <label className={styles['field-label']} htmlFor="inputEmail">E-MAIL</label>
                    <input
                        id="inputEmail"
                        name="inputEmail"
                        type="email"
                        value={email}
                        onChange={onChangeInput}
                        className={`${styles['field-input']} ${isValidEmail === 1 ? styles['field-input--error'] : ''}`}
                    />
                </div>

                <div className={styles['field-group']}>
                    <label className={styles['field-label']} htmlFor="inputPosition">ODSEK/POZICIJA</label>
                    <input
                        id="inputPosition"
                        name="inputPosition"
                        type="text"
                        value={position}
                        onChange={onChangeInput}
                        className={`${styles['field-input']} ${isValidPosition === 1 ? styles['field-input--error'] : ''}`}
                    />
                </div>

                <button className={styles['submit-btn']} onClick={handleSubmit}>
                    Prijavi se &nbsp;&gt;
                </button>
            </div>
        </div>
    );
};

export default HuaweiEventLogin;
